module.exports = __webpack_public_path__ + "static/media/san-antonio-spurs.884e49c8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/data/svg/san-antonio-spurs.svg
// module id = 237
// module chunks = 0